import React from "react";
import type { PreventiveActionPlan } from "../../../../components/RCA/types";

interface RCAPreventiveActionsSectionProps {
  actions: PreventiveActionPlan[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof PreventiveActionPlan, value: any) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCAPreventiveActionsSection: React.FC<RCAPreventiveActionsSectionProps> = ({
  actions,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">L. Preventive Actions</h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Preventive Action
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Preventive Action</th>
              <th className="border p-2">Responsible Person/Team</th>
              {!readOnly && <th className="border p-2">Action</th>}
            </tr>
          </thead>
          <tbody>
            {(!actions || actions.length === 0) ? (
              <tr>
                <td
                  colSpan={readOnly ? 3 : 4}
                  className="border p-4 text-center text-gray-500"
                >
                  No preventive actions added
                </td>
              </tr>
            ) : (
              actions.map((action, index) => (
                <tr key={index}>
                  <td className="border p-2 text-center">{action.srNo}</td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={action.preventiveAction}
                      onChange={(e) =>
                        onUpdate(index, "preventiveAction", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={action.responsiblePersonOrTeam}
                      onChange={(e) =>
                        onUpdate(index, "responsiblePersonOrTeam", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  {!readOnly && (
                    <td className="border p-2 text-center">
                      <button
                        type="button"
                        onClick={() => onRemove(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCAPreventiveActionsSection;
